import { render, staticRenderFns } from "./AmbbetPanel.vue?vue&type=template&id=0e3de71e&"
import script from "./AmbbetPanel.vue?vue&type=script&lang=js&"
export * from "./AmbbetPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports